module.exports = __webpack_public_path__ + "fonts/EuclidSquare-Light.woff2";